import moment from 'moment'

const fichas = {
  fichaSaude: {
    idps_saude: null,
    idPessoa: null,
    tipoSanguineo: null,
    possuiPlanoSaude: null,
    nomePlanoSaude: null,
    possuiNecessidadeEspecial: null,
    nomeNecessidadeEspecial: null,
    possuiAlergiaMedicamento: null,
    nomeAlergiaMedicamento: null,
    realizaTratamentoMedico: null,
    nomeTratamentoMedico: null,
    possuiMedicacaoRegular: null,
    nomeMedicacaoRegular: null,
    informacaoAdicional: null,
    idMatricula: null
  },
  fichaSaida: {
    autorizacaoSaida: {
      idAutorizacaoSaida: null,
      pai: null,
      mae: null,
      responsavelFinanceiro: null,
      responsavelPedagogico: null,
      outros: null,
      idTipoAutorizacaoSaida: null
    },
    autorizacaoRetirarAluno: [
      {
        nome: null,
        cpf: null,
        parentesco: null,
        telefoneResidencial: null,
        telefoneCelular: null
      }
    ],
    transporteEscolar: {
      idTransporteEscolar: null,
      usaTransporteEscolar: null,
      naoDefinido: null,
      nomeCondutor: null,
      telefoneCondutor: null,
      idAutorizacaoSaida: null
    },
    valeTransporte: {
      idValeTransporte: null,
      sptrans: null,
      bom: null,
      naoSolicitado: true,
      idMatricula: null
    }
  }
}

const backup = Object.assign({}, JSON.parse(JSON.stringify(fichas)))
const fichaIniState = fichas
const cloneBackup = item => JSON.parse(JSON.stringify(item ? backup[item] : backup))

export const ficha = {
  namespaced: true,
  state: fichaIniState,
  mutations: {
    save ( state, steps ) {
      console.log("save - steps", steps)
      // console.log(target:, target)

      const data = localStorage.getItem('matricula')
      const now = moment()

      var created_at
      const updated_at = now

      if ( !data ) {
        created_at = now
      } else {
        const current = JSON.parse(data)
        created_at = current.created_at
      }

      //clear active step
      const stepsToSave = []
      if ( steps ) {
        steps.map( k => {
          const item = Object.assign({}, k)
          item.active = false
          stepsToSave.push(item)
          // k.active = false
        })
      }
      
      const oldSteps = data?.steps
      const matricula = {
        created_at: created_at,
        updated_at: updated_at,
        matricula: state,
        steps: !stepsToSave && oldSteps || stepsToSave.length == 0 && oldSteps ? oldSteps : stepsToSave
      }
      
      // console.log(save - matricula:, matricula)
      const drop = JSON.stringify(matricula)
      localStorage.setItem('matricula', drop)

      return matricula
    },
    clear ( state, item ) {
      if ( typeof item == 'string' ) {
        state[item] = cloneBackup(item)
        return
      }

      localStorage.removeItem('matricula')

      // limpa tudo
      Object.keys(backup).forEach(key => {
        state[key] = cloneBackup(key)
      })
    }
  },
  actions: {
    get ({state}) {
      return Promise.resolve(state)
    },
    save ({commit, state}, steps) {
      commit('save', steps)
      console.log("usable state:", state)

      return Promise.resolve(state)
    },
    clear ( {commit, state}, item ) {
      console.log("clear - item:", item)
      console.log("clear - state:", state)
      commit('clear', item)

      if ( typeof item == 'string' ) {
        return Promise.resolve(state[item])
      }

      return Promise.resolve(state)
    }
  }
}
